import React, { useEffect, useState } from "react";
import WeeklyWeatherCard from "./WeeklyWeatherCard";
import CurrentWeatherCard from "./CurrentWeatherCard";

export default function WeatherCard({ city, lat, long }) {
  const [weeklydata, setWeeklyData] = useState([]);

  const [currentdata, currentsetData] = useState([]);
  const [showOverview, setShowOverview] = useState(false)

  useEffect(() => {
    fetch(
      `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${long}&units=metric&appid=${process.env.REACT_APP_API_KEY}`
    )
      .then((res) => res.json())
      .then((result) => {
        setWeeklyData(result);
        console.log(result);
      });
  }, [lat, long]);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/weather/?q=${city}&units=metric&lang=nl&APPID=${process.env.REACT_APP_API_KEY}`
    )
      .then((res) => res.json())
      .then((result) => {
        currentsetData(result);
      });
  }, [city]);

  return (
    <div className="App">
      {currentdata.main  && (
        <CurrentWeatherCard weatherData={currentdata} weeklyData={weeklydata} setShowWeekly={setShowOverview} showWeekly={showOverview} />
      )}

      {weeklydata.daily && showOverview && false && (
        <WeeklyWeatherCard weatherData={weeklydata} index="1" />
      )}
    </div>
  );
}
